import { DataListDto, FeatureDto } from '@medone/medonehp-api-client';
import { BedBoardDataListDto } from '@medone/medonehp-bedboard-client';

export interface DataState {
    loading: boolean;
    appError?: string;
    items?: DataListDto | BedBoardDataListDto;
    featureFlags: FeatureDto[];
}

export const initialState: DataState = {
    loading: true,
    appError: null,
    items: null,
    featureFlags: [],
};
